import React from 'react';
import AppRoutes from './AppRoutes';
import { ToastProvider } from './components/Toast';
import 'bootstrap/dist/css/bootstrap.min.css';


const App: React.FC = () => {
  return (
    <ToastProvider>
      <AppRoutes />
    </ToastProvider>
  );
}

export default App;
